module.exports = __webpack_public_path__ + "img/ic-home-charging.434558a5.png";